import { RouteObject } from "react-router-dom";
// reports
import { OperatorMemberDepositListPage } from "@/pages/operator/reports/member-deposit";
import { OperatorMemberWithdrawListPage } from "@/pages/operator/reports/member-withdraw";
import { OperatorTenantDepositListPage } from "@/pages/operator/reports/tenant-deposit";
import { OperatorTenantWithdrawListPage } from "@/pages/operator/reports/tenant-withdraw";
import { OperatorSelfDepositListPage } from "@/pages/operator/reports/self-deposit";
import { OperatorSelfWithdrawListPage } from "@/pages/operator/reports/self-withdraw";
// management
import { OperatorManageWalletsPage } from "@/pages/operator/management/wallets";
import { OperatorManageTenantsPage } from "@/pages/operator/management/tenants";
import { OperatorManageOptionsPage } from "@/pages/operator/management/options";
import { OperatorManageOperationsPage } from "@/pages/operator/management/operations";

export const operatorRoutes: RouteObject[] = [
  {
    path: "operator",
    children: [
      {
        path: "reports",
        children: [
          {
            path: "member-deposit",
            element: <OperatorMemberDepositListPage />,
          },
          {
            path: "member-withdraw",
            element: <OperatorMemberWithdrawListPage />,
          },
          {
            path: "tenant-deposit",
            element: <OperatorTenantDepositListPage />,
          },
          {
            path: "tenant-withdraw",
            element: <OperatorTenantWithdrawListPage />,
          },
          {
            path: "self-deposit",
            element: <OperatorSelfDepositListPage />,
          },
          {
            path: "self-withdraw",
            element: <OperatorSelfWithdrawListPage />,
          },
        ],
      },
      {
        path: "management",
        children: [
          {
            path: "wallets",
            element: <OperatorManageWalletsPage />,
          },
          {
            path: "tenants",
            element: <OperatorManageTenantsPage />,
          },
          {
            path: "options",
            element: <OperatorManageOptionsPage />,
          },
          {
            path: "operations",
            element: <OperatorManageOperationsPage />,
          },
        ],
      },
    ],
  },
];
